module.exports = __webpack_public_path__ + "img/managerweblogo.dab1aa0f.png";